<template>
  <div class="content-container">
    <ContentBox title="基本信息" class="content-box">
      <el-form
        ref="mediaForm"
        label-width="120px"
        class="demo-ruleForm"
        hide-required-asterisk
        label-position="left"
        :rules="rules"
        :model="mediaForm"
      >
        <el-row>
          <el-col :span="18">
            <el-form-item v-if="accountType === '1'" label="广告主" prop="partnerId">
              <el-select
                class="demo-ruleForm-select"
                :disabled="formDisabled || uploadDisabled"
                v-model="mediaForm.partnerId"
                clearable
                filterable
                placeholder="请选择广告主"
                @change="handlePartnerChange"
              >
                <el-option
                  v-for="item in partnerOptions"
                  :key="'p1' + item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="广告位" prop="spaceId">
              <el-select
                :disabled="formDisabled || uploadDisabled"
                class="demo-ruleForm-select"
                :value="mediaForm.spaceId"
                placeholder="请选择广告位"
                clearable
                filterable
                @input="handleSpaceChanged"
              >
                <el-option
                  v-for="item in spaceList"
                  :key="item.spaceId"
                  :label="item.spaceName"
                  :value="item.spaceId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="广告提示语" v-if="showTips" prop="tipsDetail">
              <AdTipsEditor
                :disabled="formDisabled || uploadDisabled"
                :tipsTempId="mediaForm.tipsTempId"
                :tipsDetail="mediaForm.tipsDetail"
                :spaceId="mediaForm.spaceId"
                @save="saveTips"
              />
            </el-form-item>
            <el-form-item label="媒体方" prop="cableChannelIdList">
              <CheckBoxGroup
                v-model="mediaForm.cableChannelIdList"
                :options="channelList"
                :checkDisabled="checkDisabled"
                @input="handleCableChannelInput"
              ></CheckBoxGroup>
            </el-form-item>
            <el-form-item label="上传素材" prop="mediaClassId">
              <div class="flex-form-item">
                <el-radio-group
                  ref="mediaType"
                  :disabled="formDisabled"
                  :value="mediaForm.mediaClassId"
                  @input="handleChangeMediaType($event)"
                >
                  <el-radio-button
                    v-for="(item, index) in limitMediaType"
                    :label="item"
                    name="mediaClassId"
                    :key="index"
                    >{{ transferMediaType(item) }}</el-radio-button
                  >
                </el-radio-group>
                <template v-if="mode === 'create' || mediaForm.checkStatus === 0">
                  <div v-if="showSuccessTip" class="inline-tip">
                    上传成功数: {{ mediaForm.mediaList.length }}
                  </div>
                  <div
                    v-if="showGuideIconTips && mediaForm.mediaList.length"
                    class="upload-tip"
                  >
                    TIPS: 弹窗引导非必需上传，只有在建单时需要配置交互事件时才需要上传
                  </div>
                  <div v-else-if="showResUpload" class="upload-tip">
                    TIPS: 不可批量上传，物料个数大于等于1即可
                  </div>
                  <div v-else class="upload-tip">
                    TIPS: 可一次选择多个文件批量上传，生成多个素材
                  </div>
                </template>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              v-if="isMaterialPackage"
              prop="mediaName"
              :rules="[{ required: true, message: '请选择物料包' }]"
            >
              <div class="mate-select-box">
                <div class="image-box">
                  <el-image v-if="materialIcon" :src="materialIcon" fit="contain">
                    <div slot="error" class="error-icon">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <div
                    v-if="!formDisabled"
                    class="mask"
                    :style="materialIcon ? '' : 'opacity:1'"
                  >
                    <div class="mask-button">
                      <el-button @click.stop="dialogTableVisible = true"
                        >选择物料包</el-button
                      >
                    </div>
                  </div>
                </div>
                <el-input
                  v-model="mediaForm.mediaName"
                  clearable
                  size="small"
                  show-word-limit
                  maxlength="45"
                  placeholder="素材名称"
                ></el-input>
              </div>
            </el-form-item>
            <div v-else-if="showResUpload">
              <UploadByResolution
                :mode="mode"
                :mediaForm="mediaForm"
                :adSpaceModel="adSpaceModel"
                :showDuration="showDuration"
                :guideImgConfig="guideImgConfig"
                :coverImgConfig="coverImgConfig"
                :bgImageConfig="bgImageConfig"
              />
              <el-row>
                <el-col :span="18">
                  <el-form-item
                    label="素材名称"
                    prop="mediaName"
                    :rules="[{ required: true, message: '请填写素材名称' }]"
                  >
                    <el-input
                      v-model="mediaForm.mediaName"
                      clearable
                      show-word-limit
                      maxlength="45"
                      placeholder="素材名称"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div v-else style="margin: 0 20px 20px 120px">
              <MediaUploader
                :mode="mode"
                :mediaForm="mediaForm"
                :showDuration="showDuration"
                :adSpaceModel="adSpaceModel"
                :mediaConfig="mediaConfig"
                :guideImgConfig="guideImgConfig"
                :coverImgConfig="coverImgConfig"
                :bgImageConfig="bgImageConfig"
              />
            </div>
          </el-col>
          <el-col :span="24">
            <el-form-item
              v-if="showDuration && mediaForm.mediaClassId === 1"
              label="显示时长"
              prop="duration"
            >
              <div class="flex-box">
                <el-input-number
                  v-model="mediaForm.duration"
                  controls-position="right"
                  :disabled="vedioDisabled"
                  :min="minDuration"
                  :max="maxDuration"
                ></el-input-number
                >&nbsp; 秒
                <div class="remark-tip">
                  请输入{{ this.minDuration }}到{{ this.maxDuration }}的数
                </div>
              </div>
            </el-form-item>
            <el-form-item label="显示位置" v-if="showCoordinate">
              <el-radio-group v-model="mediaForm.locationType">
                <el-radio-button :label="0">全屏</el-radio-button>
                <el-radio-button :label="10">自定义</el-radio-button>
                <el-radio-button :label="1">上左</el-radio-button>
                <el-radio-button :label="2">上中</el-radio-button>
                <el-radio-button :label="3">上右</el-radio-button>
                <el-radio-button :label="4">中左</el-radio-button>
                <el-radio-button :label="5">居中</el-radio-button>
                <el-radio-button :label="6">中右</el-radio-button>
                <el-radio-button :label="7">下左</el-radio-button>
                <el-radio-button :label="8">下中</el-radio-button>
                <el-radio-button :label="9">下右</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="动画效果" v-if="showEffect">
              <el-radio-group v-model="mediaForm.effect">
                <el-radio-button
                  v-for="(item, index) in $consts.effectList"
                  :label="item.label"
                  :key="index"
                  >{{ item.value }}</el-radio-button
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="X轴"
              v-if="showCoordinate && mediaForm.locationType === 10"
              prop="coordinateX"
            >
              <el-input-number
                v-model.trim="mediaForm.coordinateX"
                controls-position="right"
                :max="10000000"
              ></el-input-number
              >&nbsp;px
            </el-form-item>
            <el-form-item
              label="Y轴"
              v-if="showCoordinate && mediaForm.locationType === 10"
              prop="coordinateY"
            >
              <el-input-number
                v-model.trim="mediaForm.coordinateY"
                controls-position="right"
                :max="10000000"
              ></el-input-number
              >&nbsp;px
            </el-form-item>
            <template v-if="showLandPage">
              <el-form-item class="land-page-item" label="跳转地址">
                <el-radio-group v-model="landPage" @change="handleLandPageChange">
                  <el-radio-button :label="0">无</el-radio-button>
                  <el-radio-button :label="1">自定义</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="landPage === 1"
                class="land-page-item"
                label-width="20px"
              >
                <el-input
                  v-model="mediaForm.landingPage"
                  v-noEmoji
                  class="land-page-input"
                  maxlength="100"
                  placeholder="请输入落地页地址"
                ></el-input>
              </el-form-item>
            </template>
            <template v-if="adSpacePaddingList.length > 0">
              <el-form-item label="四周边距" class="padding-item">
                <el-col v-if="showEditPadding" :span="6">
                  <el-select v-model="spacePaddingId" @change="setMediaPadding">
                    <el-option
                      v-for="(item, index) in adSpacePaddingList"
                      :key="index"
                      :value="item.spacePaddingId"
                      :label="item.spacePaddingName"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="3">
                  <el-input v-model="mediaPadding.paddingTop" :readonly="true">
                    <span slot="prepend">上</span>
                  </el-input>
                </el-col>
                <el-col :span="3">
                  <el-input v-model="mediaPadding.paddingRight" :readonly="true">
                    <span slot="prepend">右</span>
                  </el-input>
                </el-col>
                <el-col :span="3">
                  <el-input v-model="mediaPadding.paddingBottom" :readonly="true">
                    <span slot="prepend">下</span>
                  </el-input>
                </el-col>
                <el-col :span="3">
                  <el-input v-model="mediaPadding.paddingLeft" :readonly="true">
                    <span slot="prepend">左</span>
                  </el-input>
                </el-col>
                <el-col v-if="!showEditPadding" :span="3">
                  <el-button icon="el-icon-edit" @click="showEditPadding = true"
                    >编辑</el-button
                  >
                </el-col>
              </el-form-item>
            </template>
          </el-col>
        </el-row>
      </el-form>
    </ContentBox>
    <ContentBox class="content-box">
      <el-button @click="handleCancel"> <i class="icon-ios-undo"></i>取消 </el-button>
      <el-button
        type="primary"
        :disabled="saveBtnDisabled || uploadDisabled"
        :loading="buttonSubmitLoading"
        @click="handleSave"
        >保存</el-button
      >
    </ContentBox>
    <el-dialog
      destroy-on-close
      :visible.sync="dialogTableVisible"
      width="70%"
      @opened="openMaterialDialog"
    >
      <template slot="title">
        <div class="dialog-title">选择物料</div>
      </template>
      <MaterialTable ref="materialTable" @select-data="handleSelectMaterial" />
    </el-dialog>
  </div>
</template>
<script>
import CheckBoxGroup from '@/components/CheckBoxGroup'
import MaterialTable from '@/components/MaterialTable'
import AdTipsEditor from '@/components/media/AdTipsEditor.vue'
import MediaUploader from './components/MediaUploader.vue'
import UploadByResolution from './components/UploadByResolution.vue'

export default {
  components: {
    CheckBoxGroup,
    MaterialTable,
    AdTipsEditor,
    MediaUploader,
    UploadByResolution
  },
  data() {
    var validateChannel = (rule, val, callback) => {
      if (this.channelList.length > 0 && val && val.length === 0) {
        callback(new Error('请选择媒体方'))
      } else {
        callback()
      }
    }
    var validateTips = (rule, val, callback) => {
      if (this.adSpaceModel.spaceNo === 'CCADTV10001' && !val) {
        callback(new Error('开机广告提示语必填'))
      } else {
        callback()
      }
    }
    return {
      accountType: 0,
      partnerOptions: [],
      spaceList: [], // 广告位
      vedioDisabled: false,
      materialIcon: '',
      isShowCommonUpload: false,
      showSaveButton: true,
      adSpaceModel: {},
      mediaForm: {
        mediaId: '',
        mediaName: '',
        spaceId: '',
        mediaClassId: '',
        duration: '',
        locationType: '',
        effect: '',
        tipsTempId: undefined,
        tipsDetail: '',
        cableChannelIdList: [],
        coordinateX: '',
        coordinateY: '',
        partnerId: '',
        mediaIcon: undefined,
        originalMediaPath: '',
        checkStatus: 0,
        materialId: 0,
        landingPage: '',
        mediaPadding: undefined,
        mediaList: [],
        resolutionList: [],
        guideIcon: '',
        minIcon: '',
        bgIcon: ''
      },
      landPage: 0,
      oldMediaForm: {},
      limitMediaType: [],
      mediaClassList: [],
      channelList: [],
      checkDisabled: false,
      channelOptions: [],
      showCoordinate: false,
      showEffect: false, // 是否显示【动画效果】
      showDuration: false,
      showTips: false,
      minDuration: null,
      maxDuration: null,
      mediaConfig: {
        accept: '',
        format: '',
        limitSize: 0,
        fileTips: ''
      },
      rules: {
        partnerId: [{ required: true, message: '请选择广告主', trigger: 'change' }],
        spaceId: [{ required: true, message: '请选择广告位', trigger: 'change' }],
        tipsDetail: [{ validator: validateTips, trigger: 'change' }],
        mediaClassId: [{ required: true, message: '请选择形式', trigger: 'change' }],
        coordinateX: [{ required: true, message: '请输入X轴', trigger: 'blur' }],
        coordinateY: [{ required: true, message: '请输入Y轴', trigger: 'blur' }],
        cableChannelIdList: [
          { validator: validateChannel, message: '请选择媒体方', trigger: 'change' }
        ]
      },
      buttonSubmitLoading: false,
      dialogTableVisible: false,
      showLandPage: false,
      adSpacePaddingList: [],
      spacePaddingId: undefined,
      mediaPadding: {
        paddingTop: '',
        paddingBottom: '',
        paddingLeft: '',
        paddingRight: ''
      },
      showEditPadding: true,
      bgImageConfig: {
        limitSize: 0,
        fileTips: ''
      },
      coverImgConfig: {
        limitSize: 0,
        fileTips: ''
      },
      guideImgConfig: {
        limitSize: 0,
        fileTips: ''
      },
      showGuideIconTips: false
    }
  },
  props: ['mode', 'id', 'materialObj'],
  computed: {
    saveBtnDisabled() {
      return (
        !this.mediaForm.partnerId ||
        (this.isMaterialPackage && !this.materialIcon) ||
        (!this.isMaterialPackage &&
          !this.showResUpload &&
          this.mediaForm.mediaList.length === 0) ||
        (!this.isMaterialPackage &&
          this.showResUpload &&
          this.mediaForm.resolutionList.every((item) => item.mediaIcon === ''))
      )
    },
    formDisabled() {
      return this.mode === 'edit' && this.mediaForm.checkStatus !== 0
    },
    uploadDisabled() {
      if (this.showResUpload) {
        return this.mediaForm.resolutionList.some((item) => item.status === 'uploading')
      }
      return this.mediaForm.mediaList.some((item) => item.status === 'uploading')
    },
    isMaterialPackage() {
      if (!this.adSpaceModel.adSpaceMediaLimits) {
        return false
      }
      const mediaLimit = this.adSpaceModel.adSpaceMediaLimits.find(
        (item) => item.mediaClassId === this.mediaForm.mediaClassId
      )
      return mediaLimit.format.indexOf('json') > -1
    },
    showSuccessTip() {
      return (
        !this.formDisabled &&
        !this.showResUpload &&
        this.mediaForm.mediaList.every((item) => item.status === 'success')
      )
    },
    showResUpload() {
      return (
        this.adSpaceModel.supportThum === 0 &&
        this.adSpaceModel.autoResize === 0 &&
        (this.mediaForm.mediaClassId === 1 ||
          this.mediaForm.mediaClassId === 2 ||
          this.mediaForm.mediaClassId === 4)
      )
    },
    isUploaded() {
      return (
        (this.showResUpload &&
          this.mediaForm.resolutionList.some((item) => item.status === 'success')) ||
        (!this.showResUpload && this.mediaForm.mediaList.length > 0)
      )
    },
    needCoverImg() {
      return (
        this.adSpaceModel.brandIcon &&
        (this.mediaForm.mediaClassId === 2 ||
          (this.mediaForm.mediaClassId === 1 &&
            this.adSpaceModel.spaceNo === 'CCADTV10058'))
      )
    },
    showBgImage() {
      return this.adSpaceModel.bgImage === 1
    }
  },
  methods: {
    handleChangeMediaType(mediaClassId) {
      // 切换类型
      if (!this.isUploaded) {
        this.mediaForm.mediaClassId = mediaClassId
        this.mediaForm.originalMediaPath = ''
        this.initUpload(mediaClassId)
      } else {
        this.$confirm('修改素材形式将清空已上传素材，确认修改?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true,
          showClose: false
        })
          .then(() => {
            this.mediaForm.mediaClassId = mediaClassId
            this.mediaForm.mediaList = []
            this.mediaForm.originalMediaPath = ''
            this.initUpload(mediaClassId)
          })
          .catch(() => {
            const nodes = document.getElementsByName('mediaClassId')
            if (nodes) {
              nodes.forEach((node) => {
                if (node.value * 1 === this.mediaForm.mediaClassId) {
                  node.checked = true
                }
              })
            }
          })
      }
    },
    handleSpaceChanged(spaceId) {
      if (this.isUploaded) {
        this.$confirm('修改广告位将清空已上传素材，确认修改?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true,
          showClose: false
        })
          .then(() => {
            this.mediaForm.mediaList = []
            this.mediaForm.spaceNo = ''
            this.mediaForm.adSpaceName = ''
            this.mediaForm.duration = null
            this.mediaForm.locationType = null
            this.mediaForm.materialId = 0
            this.setSpaceInfo(spaceId)
            this.mediaForm.originalMediaPath = ''
            this.initUpload(this.mediaForm.mediaClassId)
          })
          .catch(() => {})
      } else {
        this.setSpaceInfo(spaceId)
        this.mediaForm.originalMediaPath = ''
        this.initUpload(this.mediaForm.mediaClassId)
      }
    },
    // 选中广告位之后处理相关逻辑
    setSpaceInfo(spaceId) {
      this.mediaForm.spaceId = spaceId
      // 设置可选的素材类型
      this.adSpaceModel = this.spaceList.find((item) => item.spaceId === spaceId)
      if (this.adSpaceModel.spaceNo === 'CCADTV10004') {
        this.showEffect = true
        this.mediaForm.effect = '0'
      } else {
        this.showEffect = false
        this.mediaForm.effect = ''
      }
      let limitMediaTypeSet = new Set()
      this.adSpaceModel.adSpaceMediaLimits.forEach(function (obj) {
        limitMediaTypeSet.add(obj.mediaClassId)
      })
      this.limitMediaType = [...limitMediaTypeSet]
      // 默认选择第一个素材类型
      this.mediaForm.mediaClassId = this.limitMediaType[0]
      // 根据广告位过滤媒体方
      this.handleChannel(this.adSpaceModel.spaceNo)
      // 处理显示位置
      this.handleCoordinate()
      // 处理广告提示语
      this.handleTip(this.mediaForm.spaceId, 0)
      // 落地页
      this.showLandPage = this.adSpaceModel.needLandingPage === 1

      this.setCoverImgConfig()
      // 四周边距
      this.adSpacePaddingList = this.adSpaceModel.adSpacePaddingList || []
    },
    handleSpace(spaceId) {
      this.adSpaceModel = this.spaceList.find((item) => item.spaceId === spaceId)
      if (this.adSpaceModel.spaceNo === 'CCADTV10004') {
        this.showEffect = true
      }
      this.setCoverImgConfig()
      this.mediaForm.spaceId = spaceId
      // 过滤广告位下的媒体方
      if (this.mode === 'create') {
        this.handleChannel(this.adSpaceModel.spaceNo)
      }
      // 设置可选的素材类型
      let limitMediaTypeSet = new Set()
      this.adSpaceModel.adSpaceMediaLimits.forEach(function (obj) {
        limitMediaTypeSet.add(obj.mediaClassId)
      })
      this.limitMediaType = [...limitMediaTypeSet]
      // 默认选择第一个素材类型
      if (!this.mediaForm.mediaClassId) {
        this.mediaForm.mediaClassId = this.limitMediaType[0]
      }
      if (!this.isUploaded) {
        this.initUpload(this.mediaForm.mediaClassId)
      } else {
        this.handleDuration()
      }
      this.handleCoordinate()
      this.handleTip(this.mediaForm.spaceId)
      // 落地页
      this.showLandPage = this.adSpaceModel.needLandingPage === 1
      // 四周边距
      this.adSpacePaddingList = this.adSpaceModel.adSpacePaddingList || []
    },
    setCoverImgConfig() {
      if (this.adSpaceModel.brandIcon === 0) return
      const fileTips = ['png/jpg格式']
      this.adSpaceModel.spaceCoverIconConfigList.forEach((item) => {
        fileTips.push(
          `${item.widthLimit}*${item.heightLimit}适用于<span style="color:#f78400">${item.coverIconConfigName}</span>, 不超过${item.sizeLimit}K`
        )
      })
      this.coverImgConfig.fileTips = fileTips.join('<br>')
    },
    handleChannel(val) {
      this.mediaForm.cableChannelIdList = []
      if (!val) return
      if (!this.mediaForm.partnerId) return
      const params = {
        spaceNo: val,
        partnerId: this.mediaForm.partnerId
      }
      this.$service.getChannelList(params).then((data) => {
        if (data) {
          this.channelOptions = data
          let channel = this.channelOptions.filter(
            (item) => item.spaceNo.includes(val) || !item.spaceNo
          )
          if (channel && channel.length > 0) {
            this.channelList = channel.map((item) => {
              if (item.selectBox === 1) {
                this.mediaForm.cableChannelIdList.push(item.cableChannelId)
                this.oldMediaForm = this.cloneDeep(this.mediaForm)
              }
              return {
                value: item.cableChannelId,
                label: item.cableName,
                cableNo: item.cableNo
              }
            })
          }
        }
      })
    },
    handleTip(spaceId, type) {
      // 是服务端渲染1才需要提示语转码
      if (this.adSpaceModel.adTip === 1) {
        this.showTips = true
        // 只有新增素材和修改广告位时候才使用广告位默认模板
        if (this.mode === 'create' || type === 0) {
          this.$service
            .getAdDefaultTip({ spaceId: spaceId, defFlagType: 1 })
            .then((res) => {
              if (res) {
                this.mediaForm.tipsTempId = res.tempId
                this.mediaForm.tipsDetail = res.tipsDetail
                  ? JSON.stringify(res.tipsDetail)
                  : ''
                if (this.mode === 'create') {
                  this.oldMediaForm = this.cloneDeep(this.mediaForm)
                }
              }
            })
        }
      } else {
        this.showTips = false
        this.mediaForm.tipsTempId = undefined
        this.mediaForm.tipsDetail = ''
      }
    },
    handleCoordinate() {
      // 是自定义坐标1则显示
      if (this.adSpaceModel.coordinate === 1) {
        this.showCoordinate = true
        if (!this.mediaForm.locationType) {
          this.mediaForm.locationType = this.adSpaceModel.coordinateType
          this.mediaForm.coordinateX = this.adSpaceModel.coordinateX
          this.mediaForm.coordinateY = this.adSpaceModel.coordinateY
        }
      } else {
        this.showCoordinate = false
      }
    },
    handleDuration() {
      // 自定义时长,0-否1-是  是自定义时长并且素材类型并且是图片时候，显示时长
      if (this.adSpaceModel.durationint === 1) {
        if (this.mediaForm.mediaClassId === 1) {
          this.showDuration = true
          if (!this.mediaForm.duration) {
            this.mediaForm.duration = this.adSpaceModel.duratDefint
          }
          this.minDuration = this.adSpaceModel.duratMinint
          this.maxDuration = this.adSpaceModel.duratMaxint
        }
      } else {
        this.mediaForm.duration = null
        this.showDuration = false
        this.minDuration = null
        this.maxDuration = null
      }
    },
    initUpload(mediaClassId) {
      this.handleDuration()
      this.mediaForm.mediaClassId = mediaClassId
      this.mediaForm.resolutionList = []
      let mediaLimitMap = new Map()
      let size = ''
      let wh = ''
      let limitFormat = ''
      let limitFormatArray = []
      if (this.adSpaceModel.adSpaceMediaLimits) {
        limitFormatArray = this.adSpaceModel.adSpaceMediaLimits
          .filter((limit) => limit.mediaClassId === mediaClassId)
          .reduce((prev, cur) => {
            prev = prev.concat(cur.format.split(','))
            return prev
          }, [])
        let limitFormatSet = new Set(limitFormatArray)
        let acceptFormat = ''
        if (limitFormatSet.size > 0) {
          limitFormatSet.forEach((item) => {
            limitFormat += `${item}/`
            acceptFormat += `.${item},`
          })
        }
        this.mediaConfig.accept = acceptFormat.substring(0, acceptFormat.length - 1)
        this.mediaConfig.format = limitFormat.substring(0, limitFormat.length - 1)
        // 素材分类
        if (this.limitMediaType.length > 0) {
          // 处理每个分类下的素材
          this.limitMediaType.forEach((id) => {
            let arr = this.adSpaceModel.adSpaceMediaLimits.filter(
              (limit) => id === limit.mediaClassId
            )
            mediaLimitMap.set(id, arr)
          })
        }
        if (mediaClassId === 1 || mediaClassId === 2 || mediaClassId === 4) {
          let mediaArr = mediaLimitMap.get(mediaClassId)
          let maxWdith = Math.max.apply(
            Math,
            mediaArr.map((o) => o.width)
          )
          let maxResolution = mediaArr.find((a) => a.width === maxWdith)
          this.mediaConfig.limitSize = Math.max.apply(
            Math,
            mediaArr.map((o) => o.size)
          )

          if (this.adSpaceModel.supportThum === 0) {
            if (this.adSpaceModel.autoResize === 1) {
              // 与尺寸规定相等，【自动生成素材】为是，素材的分辨率必须等于素材类型中【素材要求】中的最大分辨率
              wh = `${maxResolution.width}*${maxResolution.height}px`
            } else {
              // 与尺寸规定相等，【自动生成素材】为否，按素材的分辨率分别上传
              wh = mediaArr.map((item) => `${item.width}*${item.height}px`).join(',')
              this.mediaForm.resolutionList = mediaArr.map((item) => {
                return {
                  accept: this.mediaConfig.accept,
                  format: this.mediaConfig.format,
                  limitSize: item.size,
                  fileTips: `${item.width}*${item.height}px，${this.mediaConfig.format}，不超过${item.size}K`,
                  status: 'none',
                  percentage: 0,
                  width: item.width,
                  height: item.height,
                  url: '',
                  disabled: false
                }
              })
            }
          } else {
            // 不超过规定尺寸时分辨率大于等于 素材类型中的最大分辨率*允许最小比例；分辨率小于等于素材类型中的最大分辨率
            let minRatio = this.adSpaceModel.minRatio
            let minWidth = (maxResolution.width * (1 / minRatio)).toFixed(0)
            let minHeight = (maxResolution.height * (1 / minRatio)).toFixed(0)
            wh = `分辨率不小于${minWidth}*${minHeight}，不超过${maxResolution.width}*${maxResolution.height}`
          }
          this.mediaConfig.fileTips = `${wh}，${this.mediaConfig.format}，不超过${this.mediaConfig.limitSize}K`
          let duration =
            this.adSpaceModel.durationList && this.adSpaceModel.durationList !== '0'
              ? this.adSpaceModel.durationList
              : ''
          if ((mediaClassId === 2 || mediaClassId === 4) && duration) {
            this.mediaConfig.fileTips += `，时长${duration}S`
          }
        } else {
          let mediaFormat = mediaLimitMap.get(mediaClassId)
          let maxSize = Math.max.apply(
            Math,
            mediaFormat.map((o) => o.size)
          )
          this.mediaConfig.limitSize = maxSize
          size = `不超过${maxSize}K`
          this.mediaConfig.fileTips = size
        }
      }
      // 处理弹窗引导图配置
      this.showGuideIconTips = false
      this.guideImgConfig.limitSize = 0
      this.guideImgConfig.fileTips = ''
      const spaceGuideIconConfig = this.adSpaceModel.spaceGuideIconConfig
      if (spaceGuideIconConfig && spaceGuideIconConfig.widthLimit > 0) {
        this.showGuideIconTips = true
        this.guideImgConfig.limitSize = spaceGuideIconConfig.size
        this.guideImgConfig.fileTips = `${spaceGuideIconConfig.widthLimit}*${spaceGuideIconConfig.heightLimit}, png/jpg, 不超过${spaceGuideIconConfig.size}K`
      }
      // 背景图上传配置
      this.bgImageConfig.limitSize = 0
      this.bgImageConfig.fileTips = ''
      if (this.showBgImage) {
        this.bgImageConfig.limitSize = this.adSpaceModel.bgImageSize
        this.bgImageConfig.fileTips = `png/jpg格式<br />${this.adSpaceModel.bgImageWidth}*${this.adSpaceModel.bgImageHeight}, 不超过${this.adSpaceModel.bgImageSize}K`
      }
    },
    // 将素材类型id转为素材类型名称
    transferMediaType(item) {
      let mediaClass = this.mediaClassList.find((obj) => obj.mediaClassId === item)
      if (mediaClass) {
        return mediaClass.mediaClassName
      } else {
        return null
      }
    },
    handleSave() {
      if (
        this.showDuration &&
        this.mediaForm.mediaClassId === 1 &&
        !this.mediaForm.duration
      ) {
        return this.$message.error('请填写显示时长!')
      }
      const resList = this.mediaForm.resolutionList.filter((item) => item.mediaIcon)
      if (this.showResUpload && resList.length === 0) {
        return this.$message.error('请至少选择一个分辨率的素材上传!')
      }
      if (!this.showResUpload && this.needCoverImg && this.mediaForm.mediaList.length) {
        const noCoverImg = this.mediaForm.mediaList.some((item) => !item.minIcon)
        if (noCoverImg) {
          return this.$message.error('请上传素材封面图!')
        }
      }
      this.$refs.mediaForm.validate((valid) => {
        if (valid) {
          const apiName = this.mode === 'edit' ? 'saveMedia' : 'batchSaveMedia'
          const params = this.buildApiParam()
          this.buttonSubmitLoading = true
          // 如果是新增并且是保存草稿素材时
          this.$service[apiName](params, '操作成功')
            .then((data) => {
              this.buttonSubmitLoading = false
              if (this.$route.name === 'materialManage') {
                this.$emit('go-back')
              } else {
                this.$router.push({ name: 'materialManage' })
              }
            })
            .catch(() => {
              this.buttonSubmitLoading = false
            })
        }
      })
    },
    buildApiParam() {
      let params = this.cloneDeep(this.mediaForm)
      params.tipsDetail = params.tipsTempId === undefined ? undefined : params.tipsDetail
      params.landingPage = this.landPage ? this.mediaForm.landingPage : undefined
      delete params.mediaList
      delete params.resolutionList

      if (this.isMaterialPackage) {
        return this.mode === 'edit' ? params : [params]
      } else if (this.showResUpload) {
        delete params.webpWidth
        delete params.webpHeight
        const resList = this.mediaForm.resolutionList.filter((item) => item.mediaIcon)
        const firstMedia = resList[0]
        const webpMedia = resList.find(
          (item) => item.webpWidth !== undefined && item.webpHeight !== undefined
        )
        const newPath = resList
          .filter((item) => item.originalMediaPath)
          .map((item) => item.originalMediaPath)
          .join(',')
        if (this.mode === 'edit' && params.originalMediaPath) {
          if (newPath) {
            params.originalMediaPath = params.originalMediaPath + ',' + newPath
          }
        } else {
          params.originalMediaPath = newPath
        }
        params.mediaIcon = firstMedia.mediaIcon
        params.md5 = firstMedia.md5
        params.duration = firstMedia.duration
        if (webpMedia) {
          params.webpWidth = webpMedia.webpWidth
          params.webpHeight = webpMedia.webpHeight
        }
        params.materialId = undefined
        return this.mode === 'edit' ? params : [params]
      } else {
        delete params.webpWidth
        delete params.webpHeight
        const formList = this.mediaForm.mediaList.map((item) => {
          const form = this.cloneDeep(params)
          const media = {
            ...form,
            mediaName: item.mediaName,
            mediaIcon: item.mediaIcon,
            originalMediaPath: item.originalMediaPath,
            duration:
              this.showDuration && this.mediaForm.mediaClassId === 1
                ? this.mediaForm.duration
                : item.duration,
            md5: item.md5,
            materialId: undefined,
            guideIcon: this.showGuideIconTips && item.guideIcon ? item.guideIcon : '',
            minIcon: this.needCoverImg && item.minIcon ? item.minIcon : '',
            bgIcon: this.showBgImage && item.bgIcon ? item.bgIcon : ''
          }
          if (item.webpWidth !== undefined && item.webpHeight !== undefined) {
            media.webpWidth = item.webpWidth
            media.webpHeight = item.webpHeight
          }
          return media
        })
        return this.mode === 'edit' ? formList[0] : formList
      }
    },
    handleCancel() {
      const newForm = this.mediaForm
      const isChange = this.$consts.difference(newForm, this.oldMediaForm)
      if (Object.keys(isChange).length === 0) {
        this.$emit('go-back')
      } else {
        this.$confirm('页面内容未保存，确定要离开吗？', '提示', {
          confirmButtonText: '离开页面',
          cancelButtonText: '留在页面',
          center: true,
          type: 'warning'
        })
          .then(() => {
            this.$emit('go-back')
          })
          .catch(() => {})
      }
    },
    getAvailableCustomer() {
      this.partnerOptions = []
      if (this.accountType !== '1') return
      this.$service.getAvailableCustomer().then((data) => {
        this.partnerOptions = (data || [])
          .filter((item) => item.parentId !== 0)
          .map((item) => {
            return {
              value: item.partnerId,
              label: item.partnerName,
              checkStatus: item.checkStatus
            }
          })
      })
    },
    // 编辑保存提示语
    saveTips(data) {
      const oldTempId = this.mediaForm.tipsTempId
      const oldTipsDetail = this.mediaForm.tipsDetail
      this.mediaForm.tipsTempId = undefined
      this.mediaForm.tipsDetail = ''
      if (this.isUploaded) {
        this.$confirm('修改广告提示语后需要重新上传素材，是否确认修改？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true,
          showClose: false
        })
          .then(() => {
            this.mediaForm.tipsTempId = data.tipsTempId
            this.mediaForm.tipsDetail = data.tipsDetail
            this.mediaForm.mediaList = []
            this.mediaForm.originalMediaPath = ''
            this.mediaForm.duration = this.adSpaceModel.duratDefint
            this.initUpload(this.mediaForm.mediaClassId)
          })
          .catch(() => {
            this.mediaForm.tipsTempId = oldTempId
            this.mediaForm.tipsDetail = oldTipsDetail
          })
      } else {
        this.mediaForm.tipsTempId = data.tipsTempId
        this.mediaForm.tipsDetail = data.tipsDetail
      }
    },
    getSpaceList() {
      this.$service.getEnableSpace().then((data) => {
        if (data.spaceList) {
          this.spaceList = data.spaceList.filter((item) => item.spaceStatus === 1)
          if (this.mode === 'edit') {
            this.getMediaDetail()
          } else {
            // 默认选择第一个广告位
            let spaceId = this.spaceList[0].spaceId
            if (this.materialObj) {
              spaceId = this.materialObj.spaceId
              this.mediaForm.materialId = this.materialObj.materialId
              this.mediaForm.materialName = this.materialObj.materialName
              this.mediaForm.mediaName = this.mediaForm.mediaName
                ? this.mediaForm.mediaName
                : this.materialObj.materialName
            }
            this.handleSpace(spaceId)
            this.materialIcon = this.materialObj ? this.materialObj.materialIcon : ''
          }
        }
      })
    },
    getMediaDetail() {
      this.$service
        .findMedia({ mediaId: this.id })
        .then((data) => {
          if (data) {
            this.mediaForm = { ...this.mediaForm, ...data }
            if (data.mediaCableChannelList && data.mediaCableChannelList.length > 0) {
              this.mediaForm.cableChannelIdList = data.mediaCableChannelList.map(
                (item) => item.cableChannelId
              )
            }
            this.setReviewCableChannel()
            const notEditable =
              data.checkStatus === 1 || data.checkStatus === 2 || data.checkStatus === 4
            if (notEditable && data.mediaClassId === 2) {
              this.vedioDisabled = true
            }
            // 如果传1表示在详情页加载时候处理广告位逻辑，刚开始不校验重新上传素材
            this.handleSpace(this.mediaForm.spaceId)
            if (this.showResUpload) {
              if (notEditable) {
                const resolutions = data.mediaDetailList.map(
                  (detail) => detail.resolution
                )
                this.mediaForm.resolutionList = this.mediaForm.resolutionList.filter(
                  (item) => resolutions.includes(`${item.width}*${item.height}`)
                )
              }
              this.mediaForm.resolutionList.forEach((item) => {
                const detail = data.mediaDetailList.find(
                  (detail) => detail.resolution === `${item.width}*${item.height}`
                )
                if (detail) {
                  item.url = detail.mediaIconUrl
                  item.fileList = [{}]
                  item.mediaIcon = detail.mediaIcon
                  item.md5 = detail.md5
                  item.status = 'success'
                  item.disabled = true
                }
              })
            } else {
              this.mediaForm.mediaList = [
                {
                  url: data.mediaIconUrl,
                  mediaName: data.mediaName,
                  md5: data.md5,
                  mediaIcon: data.mediaIcon,
                  guideIcon: data.guideIcon,
                  minIcon: data.minIcon,
                  bgIcon: data.bgIcon,
                  originalMediaPath: data.originalMediaPath,
                  webpWidth: data.webpWidth,
                  webpHeight: data.webpHeight,
                  status: 'success',
                  percentage: 0
                }
              ]
            }
            if (this.mediaForm.mediaPadding) {
              const paddingArr = this.mediaForm.mediaPadding.split(',')
              this.mediaPadding = {
                paddingTop: paddingArr[0],
                paddingRight: paddingArr[1],
                paddingBottom: paddingArr[2],
                paddingLeft: paddingArr[3]
              }
              this.showEditPadding = false
            }
            if (this.mediaForm.mediaDetailList && this.mediaForm.mediaDetailList.length) {
              this.mediaForm.locationType = this.mediaForm.mediaDetailList[0].locationType
              this.mediaForm.coordinateX = this.mediaForm.mediaDetailList[0].coordinateX
              this.mediaForm.coordinateY = this.mediaForm.mediaDetailList[0].coordinateY
              this.mediaForm.effect = this.mediaForm.mediaDetailList[0].effect
              this.mediaForm.duration = this.mediaForm.mediaDetailList[0].duration
              this.landPage = this.mediaForm.mediaDetailList[0].landingPage ? 1 : 0
              this.mediaForm.landingPage = this.mediaForm.mediaDetailList[0].landingPage
              this.mediaForm.mediaList[0].duration =
                this.mediaForm.mediaDetailList[0].duration
            }
            this.materialIcon = data.mediaIconUrl
            this.oldMediaForm = this.cloneDeep(this.mediaForm)
          }
        })
        .catch(() => {})
    },
    // 编辑回显媒体方
    setReviewCableChannel() {
      const space = this.spaceList.find((item) => item.spaceId === this.mediaForm.spaceId)
      const params = {
        partnerId: this.mediaForm.partnerId,
        spaceNo: this.mediaForm.spaceNo
      }
      this.$service.getChannelList(params).then((data) => {
        if (data) {
          this.channelOptions = data
          let channel = this.channelOptions.filter(
            (item) => item.spaceNo.includes(space.spaceNo) || !item.spaceNo
          )
          if (channel && channel.length > 0) {
            this.channelList = channel.map((item) => {
              if (
                this.mediaForm.cableChannelIdList &&
                this.mediaForm.cableChannelIdList.length > 0 &&
                this.mediaForm.checkStatus !== 0
              ) {
                this.checkDisabled = true
                return {
                  value: item.cableChannelId,
                  label: item.cableName,
                  disabled: this.mediaForm.cableChannelIdList.includes(
                    item.cableChannelId
                  ),
                  cableNo: item.cableNo
                }
              } else {
                this.checkDisabled = false
                return {
                  value: item.cableChannelId,
                  label: item.cableName,
                  cableNo: item.cableNo
                }
              }
            })
          }
        }
      })
    },
    openMaterialDialog() {
      this.$refs.materialTable.handleSearch()
    },
    handleSelectMaterial(rowData) {
      this.dialogTableVisible = false
      this.mediaForm.materialId = rowData.materialId
      this.mediaForm.materialName = rowData.materialName
      this.materialIcon = rowData.materialIcon
      if (!this.mediaForm.mediaName) {
        this.mediaForm.mediaName = rowData.materialName
      }
    },
    initData() {
      this.getAvailableCustomer()
      this.getSpaceList()
    },
    handleCableChannelInput(val) {
      const cableChannel = this.channelList.filter((item) => {
        return val.indexOf(item.value) > -1 && item.cableNo === 'IQIYI'
      })
      if (cableChannel.length === 0) {
        return
      }
      if (!this.mediaForm.partnerId) {
        this.mediaForm.cableChannelIdList = val.filter(
          (item) => item !== cableChannel[0].value
        )
        this.$message.error('请先选择广告主，才能选择此媒体方')
      } else {
        const params = {
          cableNo: 'IQIYI',
          partnerId: this.mediaForm.partnerId
        }
        this.$service.getCabelStatus(params).then((res) => {
          if (res.data !== 0) {
            this.mediaForm.cableChannelIdList = val.filter(
              (item) => item !== cableChannel[0].value
            )
            this.$message.error('所选广告主未通过爱奇艺审核')
          }
        })
      }
    },
    handleLandPageChange(val) {
      this.mediaForm.landingPage = ''
    },
    handlePartnerChange(val) {
      this.handleChannel(this.adSpaceModel.spaceNo)
    },
    setMediaPadding(val) {
      const mediaPadding = this.adSpacePaddingList.find(
        (item) => val === item.spacePaddingId
      )
      if (!mediaPadding) return
      this.mediaPadding = {
        paddingTop: mediaPadding.paddingTop,
        paddingRight: mediaPadding.paddingRight,
        paddingBottom: mediaPadding.paddingBottom,
        paddingLeft: mediaPadding.paddingLeft
      }
      this.mediaForm.mediaPadding = Object.keys(this.mediaPadding)
        .map((key) => {
          return this.mediaPadding[key]
        })
        .join(',')
    }
  },
  created() {
    this.$service.getMediaClass().then((data) => {
      if (data) {
        this.mediaClassList = data
      }
    })
    this.accountType = this.$service.state.user.accountType
    // accountType =0，广告主
    if (this.accountType === '0') {
      this.mediaForm.partnerId = this.$service.state.user.partnerId
    }
    // 初始化广告位，广告主，广告位魔板
    this.initData()
  }
}
</script>
<style lang="stylus" scoped>
.content-container
  margin 16px
.remark-tip
  min-width 317px
  height 22px
  font-size 12px
  font-weight 400
  color rgba(0, 0, 0, 0.45)
  line-height 22px
  padding-left 28px
>>>.title
  padding-left 32px
>>>.content-box__main
  margin-left 32px
.mask
  position absolute
  top 0
  left 0
  height 100%
  width 100%
  background rgba(101, 101, 101, 0.6)
  color #fff
  opacity 0
.mask-button
  display flex
  height 100%
  justify-content center
  align-items center
.show-img-box
  display flex
  height 100%
  width 100%
  img
    width 100%
>>>.el-select
  width 100%
.flex-box
  display flex
  align-items center
>>>.el-radio-button__inner
  width 100px
.dialog-title
  border-bottom 1px solid #eee
  padding-bottom 10px
.mate-select-box
  display flex
  flex-direction column
  align-items center
  position relative
  padding 10px
  border 1px dashed #c0ccda
  border-radius 4px
  width 280px
  height 226px
  .image-box
    display flex
    position relative
    height 100%
    width 100%
    margin-bottom 10px
    &:hover .mask
      opacity 1
>>>.el-dialog__body
  padding-top 20px
.land-page-item
  display inline-block
  .land-page-input
    width 600px
.padding-item .el-col
  margin-right 20px
.flex-form-item
  display flex
  flex-flow row nowrap
  .inline-tip
    padding-left 20px
    line-height 36px
    color #999
  .upload-tip
    padding-left 40px
    line-height 36px
    color #f78400
</style>
